<template>
  <div class="card-layout">
    <div v-if="isloading" class="card-loading">
      <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#1C2D5A'" :size="80">
      </component>
    </div>
    <div v-else class="card-container">
      <div class="card-content">
        <div class="body">
          <p>{{ title }}</p>

          <strong>{{ value }}</strong>
        </div>

        <span class="footer">
          <img v-if="percent.status === 'positive'" src="/icons/crescent.svg" alt="Icone de porcentagem crescente">
          <img v-else src="/icons/decrescent.svg" alt="Icone de porcentagem decrescente">
          <p><span :class="{ positive: percent.status === 'positive', negative: percent.status === 'negative' }">{{
            percent.value }}%</span> Última semana</p>
        </span>
      </div>

      <img :src="`/components/${icon}.svg`" alt="Card Icon">
    </div>
  </div>
</template>

<script>
import * as spinners from "epic-spinners";

export default {
  name: 'InfoCard',
  components: {
    ...spinners,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      type: Number,
      default: 0,
    },
    percent: {
      type: Object,
      default: () => ({ value: 0, status: 'positive' }),
    },
    icon: {
      type: String,
      required: true,
    },
    isloading: {
      type: Boolean,
      default: false,
    }
  },
  mounted() {
    console.log(this.value)
  }
}
</script>

<style lang="scss" scoped>
.card-layout {
  flex: 1;
}

.card-loading {
  flex: 1;
  min-width: 18.4375rem;
  padding: 2.2996875rem 1rem;
  background: #FFF;
  border-radius: 14px;

  display: flex;
  justify-content: center;
  align-items: center;
}

.card-container {
  flex: 1;
  min-width: 18.4375rem;
  padding: 1rem;
  background: #FFF;
  border-radius: 14px;

  display: flex;
  justify-content: space-between;
  color: #202224;

  .card-content,
  .card-content .body {
    display: flex;
    flex-direction: column;
  }

  .card-content {
    gap: 1.5rem;

    .body {
      gap: 1rem;

      p {
        margin: 0;
        font-size: 1rem;
        font-weight: 600;
      }

      strong {
        font-size: 1.75rem;
        font-weight: 700;
      }
    }

    .footer {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-weight: 600;

      p {
        margin: 0;
      }

      img {
        width: 1.5rem;
        height: 1.5rem;
      }

      span.positive {
        color: #00B69B;
      }

      span.negative {
        color: #F93C65;
      }
    }
  }

  img {
    width: 3.75rem;
    height: 3.75rem;
  }
}
</style>